import React from "react";
import Layout from "../components/Layout";
import NavOne from "../components/NavOne";
import AdvisoryFooter from "../components/AdvisoryFooter";
import AdvisoryHome from "../components/AdvisoryHome";
import CoursesPage from "./courses";
import EpcAdvisoryPage from "./contact";
import TeachersPage from "./teachers";
import ProfilePage from "./profile";
import NewsPage from "./news";
import NewsDetailsPage from "./news-details";

const HomePage = () => {
  if (typeof window !== "undefined") {
    const pathname = window.location.pathname.replace(/\/+$/, "") || "/";

    if (pathname === "/courses" || pathname === "/cong-giao-dich") return <CoursesPage />;
    if (pathname === "/contact" || pathname === "/co-van-quan-tri-epc") return <EpcAdvisoryPage />;
    if (pathname === "/teachers" || pathname === "/hitech-talent") return <TeachersPage />;
    if (pathname === "/profile" || pathname === "/thu-vien-cua-toi") return <ProfilePage />;
    if (pathname === "/news" || pathname === "/tin-tuc") return <NewsPage />;
    if (pathname === "/news-details") return <NewsDetailsPage />;
  }

  return (
    <Layout pageTitle="Ánh Dương Advisory | Hệ điều hành quản trị EPC Solar">
      <NavOne />
      <AdvisoryHome />
      <AdvisoryFooter />
    </Layout>
  );
};

export default HomePage;
